import axios from "axios";
import { toast } from "react-toastify";
import { acquireAccessToken } from "../utils/accessToken";
import { msalInstance, msalInstanceReady } from "../msalInstance";
import { clearCachedAccessToken } from "../utils/tokenStorage";

const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token to all requests (auto refresh via MSAL)
axiosClient.interceptors.request.use(async (config) => {
  const token = await acquireAccessToken();
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global error handler for all API responses
axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Handle 401 Unauthorized - token is invalid/expired
    if (error.response?.status === 401) {
      console.log("API returned 401 - triggering re-login");
      clearCachedAccessToken();
      try {
        await msalInstanceReady;
        // Use loginRedirect for seamless re-authentication (not logout)
        await msalInstance.loginRedirect({
          scopes: ["User.Read"],
          redirectStartPage: window.location.href,
        });
      } catch (loginErr) {
        console.error("Login redirect failed", loginErr);
        window.location.href = "/";
      }
      return Promise.reject(error);
    }

    // Don't show toast if error is already handled in the calling code
    // Check if this specific error shouldn't trigger the global handler
    if (error.config?.skipGlobalErrorHandler) {
      return Promise.reject(error);
    }

    // Show maintenance message for any API error
    const errorMessage = "Service is currently under maintenance. Please try again later.";
    toast.error(errorMessage);

    return Promise.reject(error);
  }
);

export default axiosClient;
